import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class PdfExportModel extends ModeModelBase {
  override _name = 'result';
  override belongsTo = 'reportRun';
  override attributes = [
    { name: 'state', default: 'new' },
    { name: 'filename', default: '' },
    { name: 'createdAt', default: '' },
  ];
  override initialize(resource) {}
}

@Injectable({ providedIn: 'root' })
export class PdfExportModelAccessor extends ModelAccessorBase<PdfExportModel> {
  override name = 'pdfExport';
  override parentModel = 'reportRun';
  override parentIdAttribute = 'token';
  override createAttributes = [];

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.pdfExport');
  }

  createModel(resource, opts?) {
    const model = new PdfExportModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
